import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const FlightIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "FlightIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M17.1471 18.8415V19.6962C17.1471 20.1321 16.7384 20.4488 16.3161 20.3433L12.3556 19.3523C12.2501 19.325 12.1377 19.325 12.0321 19.3523L8.07159 20.3433C7.64931 20.4488 7.24066 20.1287 7.24066 19.6962V18.8415C7.24066 18.644 7.3292 18.4533 7.48244 18.3273L10.2374 16.0524C10.3907 15.9264 10.4792 15.7357 10.4792 15.5382V14.3667C10.4792 13.9989 10.1795 13.6993 9.81176 13.6993H2.84765C2.47986 13.6993 2.18018 13.3996 2.18018 13.0318V12.0783C2.18018 11.799 2.35386 11.547 2.61948 11.4517L10.0399 8.91803C10.3021 8.82268 10.4792 8.57068 10.4792 8.29143V5.39681C10.4792 4.40242 11.2999 3.58171 12.2909 3.63961C12.7234 3.66685 13.1116 3.85074 13.4011 4.1368C13.7076 4.4501 13.8983 4.87919 13.8983 5.34914V15.5382C13.8983 15.7357 13.9868 15.9264 14.1401 16.0524L16.8985 18.3273C17.0517 18.4533 17.1403 18.644 17.1403 18.8415"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M22.1802 12.0851V13.0352C22.1802 13.403 21.8805 13.7027 21.5127 13.7027H13.9016C13.9016 13.7027 13.9084 13.6924 13.9186 13.6788C14.0991 13.4609 15.3557 11.8535 15.3557 10.0044C15.3557 9.7796 15.3387 9.55143 15.2978 9.33008L21.7341 11.4585C21.9997 11.5538 22.1768 11.8058 22.1768 12.0885"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default FlightIcon;
